<template>
  <div class="overlay">
    <div class="card" :style="{ width: computedWidth }">
      <div class="header">
        <h3 class="title">{{ title }}</h3>
        <el-button class="close-btn" circle @click="$emit('close')">
          <el-icon><Close /></el-icon>
        </el-button>
      </div>
      <div class="body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Close } from '@element-plus/icons-vue'

export default {
  name: 'UiCard',
  components: { Close },
  props: {
    title: { type: String, default: '' },
    width: { type: [String, Number], default: 560 },
  },
  computed:{
    computedWidth(){
      return typeof this.width === 'number' ? `${this.width}px` : this.width
    }
  }
}
</script>

<style scoped>
@import "@/assets/css/fonts.css";

.overlay{ position:fixed; inset:0; background:rgba(0,0,0,.45); display:flex; align-items:center; justify-content:center; z-index:2000; padding:16px; box-sizing:border-box; }
.card{ width:100%; max-width:min(720px, calc(100vw - 32px)); max-height:calc(100vh - 32px); background:#fff; border-radius:12px; box-shadow:0 8px 28px rgba(0,0,0,.18); overflow:hidden; font-family:"Globo-Regular",sans-serif; display:flex; flex-direction:column; }

.header{ display:flex; align-items:center; justify-content:space-between; padding:20px 20px 14px 20px; border-bottom:1px solid #e6edf5; }
.title{ margin:0; font-family:"Globo-Bold","Globo-Regular",sans-serif; font-size:22px; color:#2b4054; }

.close-btn{ width:32px; height:32px; border-color:#dfe5eb; }
.close-btn :deep(.el-icon){ color:#9aa4af; display:flex; align-items:center; justify-content:center; }

.body{ padding:20px; background:#f5f7f8; overflow-y:auto; overflow-x:hidden; }

@media (max-width: 640px) {
  .header {
    padding: 14px 14px 10px 14px;
  }

  .title {
    font-size: 20px;
  }

  .body {
    padding: 14px;
  }
}
</style>
